import React from 'react'

const ImageMarker = ({ src, height, width }) => {
  if (!src || !height || !width) return null

  const imgStyle = {
    backgroundSize: 'cover',
    width: width + 'px',
    height: height + 'px'
  }

  return <img style={imgStyle} src={src} />
}

export default ImageMarker
